<template>
  <div class="record-container">
    <!-- pilot logs -->
    <div v-if="record.type === 'log'" :class="['record', even ? 'even' : '']">
      <p>{{record.text}}</p>
      <pre class="pre-padded">{{ recordFormatted }}</pre>
    </div>
    <!-- condensed reports -->
    <div v-if="record.type === 'report' && !fullReport" :class="['record', even ? 'even' : '']">
      <p>⚠️ Progress report, stage {{ record.key[0] }}/4: "{{ report.text }}"</p>
      <pre class="pre-padded">{{ reportFormatted }}</pre>
    </div>
    <!-- full reports -->
    <div v-if="record.type === 'report' && fullReport" :class="['record padding', even ? 'even' : '']">
      <!-- <p>⚠️ Progress report summary: "{{ report.text }}"</p> -->
      <div>
        <p class="full-report">Stage {{ record.key[0] }}/4: "{{ report.text }}"</p>
        <!-- <pre>LOCKDOWN_progress.....Stage {{ record.key[0] }}/4<br>sent..................{{ fullDate(record.daySent, false) }} (Day {{ record.daySent }})<br>received..............{{ fullDate(record.dayReceived, false) }} (Day {{ record.dayReceived }})<br>chars_used............{{ report.text.length }}/20</pre> -->
        <pre>sent.............{{ fullDate(record.daySent, false) }} (Day {{ record.daySent }})<br>received.........{{ fullDate(record.dayReceived, false) }} (Day {{ record.dayReceived }})<br>chars_used.......{{ report.text.length }}/20</pre>
        <!-- <div class="report-container" v-html="report.fullText"></div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'TextRecord',
  props: {
    record: {
      type: Object,
      required: true,
    },
    even: {
      type: Boolean,
      required: false,
      default: false,
    },
    fullReport: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    report() {
      return this.allReports.find(report => report.key === this.record.key);
    },
    recordFormatted() {
      const clone = Object.assign({}, this.record);
      delete clone.shouldDisplay;
      delete clone.text;
      delete clone.type;
      clone.type = "pilot_log"
      return clone;
    },
    reportFormatted() {
      const clone = Object.assign({}, this.record);
      delete clone.type;
      delete clone.shouldDisplay;
      delete clone.dayOffset;
      clone.type = "prog_rep"
      return clone;
    },
    ...mapState({
      allReports: state => state.reports.allReports,
    }),
    ...mapGetters([
      'fullDate',
    ]),
  },
}
</script>

<style lang="css" scoped>
.record-container {
  word-break: break-word;
  /* margin-bottom: 30px; */
}

/* .record-container::before {
  content: '';
  display: block;
  width: 100%;
  border-bottom: 1px solid var(--primary-color);
} */

.record {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px 20px;
  border-radius: 5px;
}

pre {
  min-width: 160px;
  font-size: 10px;
  /* border-left: 1px solid var(--primary-color); */
}

.pre-padded {
  margin-left: 15px;
  padding-left: 15px;
}

.padding {
  padding: 15px 20px;
}

.report-container {
  border-top: 1px solid var(--primary-color);
  /* border-bottom: 1px solid var(--primary-color); */
  /* margin-bottom: 20px; */
  margin-top: 20px;
}

.full-report {
  border-bottom: 1px solid var(--primary-color);
  /* margin-bottom: 20px; */
  padding-bottom: 15px;
}
</style>
